import { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { AmchartsReact } from "amchart4-react";

am4core.useTheme(am4themes_animated);
am4core.addLicense("ch-custom-attribution");
class SortedBarChart extends Component {
  state = {
    chart: null,
    dateAxis: null,
  };
  componentDidMount() {
    if (!!this.props && this.props.data && this.props.data.length) {
      this.createChart(); //create a chart from prev var
    }
  }
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  joinTooltipHandler = (data) => {
    if (data.length > 50) {
      let array = data.split(",");
      let newArray = [];
      let string = "";
      for (let i = 0; i < array.length; i++) {
        if (i % 3 === 0) {
          string += array[i] + ",";
          newArray.push(string);
          string = "";
        } else {
          string += array[i] + ",";
        }
      }
      return newArray.join("<br />");
    }
    return data;
  };

  createChart = () => {
    const suppress = !!this.props.suppressChartFilterInteractions;
    const clickHint = suppress ? "" : ":<hr/> Click to Apply Filter";
    let chart = am4core.create(this.props.id, am4charts.XYChart);
    chart.cursor = new am4charts.XYCursor(); //instantiate object of xy chart called chart
    chart.cursor.lineY.disabled = true; // added to remove y axis line on hover
    chart.cursor.lineX.disabled = true; // added to remove x axis line on hover

    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "key";
    categoryAxis.renderer.minGridDistance = 1;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.cursorTooltipEnabled = false;
    categoryAxis.renderer.labels.template.maxWidth = 120;
    categoryAxis.renderer.maxHeight = 0.2;
    categoryAxis.renderer.labels.template.truncate = true;
    categoryAxis.renderer.labels.template.fontSize = 10;
    // Below code is added for Making the Label as Capitalize on the X-Axis
    categoryAxis.renderer.labels.template.adapter.add("textOutput", function (text) {
      if (!!text && text !== "") {
        return text.toUpperCase();
      } else {
        return "";
      }
    });
    // end of the above code
    categoryAxis.renderer.labels.template.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    categoryAxis.renderer.labels.template.interactionsEnabled = !suppress;
    if (!suppress) {
      categoryAxis.renderer.labels.template.events.on(
        "hit",
        (ev) => {
          const item = ev.target.dataItem.dataContext.key;
          this.props.mapClickedFilterKey(this.props.analyticsFieldKeys ?? "", item ?? "");
        },
        this
      );
    }

    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.title.text = this.props.mainLabel ?? "";
    valueAxis.title.marginBottom = 5;
    valueAxis.renderer.line.strokeOpacity = 0;
    valueAxis.cursorTooltipEnabled = false;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.numberFormatter = new am4core.NumberFormatter();
    valueAxis.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
    valueAxis.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
    ];

    let series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryY = "key";
    series.dataFields.valueX = "value";
    series.adapter.add("tooltipHTML", (text, target) => {
      let data = target.tooltipDataItem.dataContext;
      // series.columns.adapter.contentWidth = 20
      if (!!this.props.mainLabel && this.props.mainLabel === "Weight (kg)") {
        return `<span className="d-flex align-items-center horizontal-line" style="font-size: 12px;text-transform: uppercase;">${this.joinTooltipHandler(data.key)}:<br/>{valueX.value}kg,<br/> {marketShare}%${clickHint}</span>`;
      } else if (this.props.mainLabel.includes("%")) {
        return `<span className="d-flex align-items-center horizontal-line" style="font-size: 12px;text-transform: uppercase;">${this.joinTooltipHandler(data.key)}:<br/>{valueX.value} ${this.props.mainLabel}:${suppress ? "" : '<hr style="border-top: 1px solid white; margin: 7px 0";/> Click to Apply Filter'}</span>`;
      } else {
        return `<span className="d-flex align-items-center horizontal-line" style="font-size: 12px;text-transform: uppercase;">${this.joinTooltipHandler(data.key)}:<br/>{valueX.value} ${this.props.mainLabel},<br/>{marketShare}%${suppress ? "" : '<hr style="border-top: 1px solid white; margin: 7px 0";/> Click to Apply Filter'}</span>`;
      }
    });
    series.columns.template.height = 20;
    series.columns.template.strokeOpacity = 0;
    series.columns.template.column.cornerRadiusBottomRight = 5;
    series.columns.template.column.cornerRadiusTopRight = 5;
    series.numberFormatter = new am4core.NumberFormatter();
    series.numberFormatter.smallNumberThreshold = 0.0001;
    series.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
    series.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
    ];

    let hoverState = series.columns.template.states.create("hover");
    hoverState.properties.fill = am4core.color("#6f08f1");
    hoverState.properties.fillOpacity = 0.8;

    // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
    series.columns.template.adapter.add("fill", function () {
      return am4core.color("#D0D5DD");
    });
    series.events.on("ready", function (ev) {
      ev.target.tooltip.zIndex = Infinity;
    });
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#271c45");
    series.tooltip.background.strokeWidth = 0;
    series.columns.template.tooltipX = am4core.percent(0);
    series.columns.template.tooltipY = am4core.percent(0);
    categoryAxis.sortBySeries = series;
    chart.data = this.props.data ?? [];
    chart.paddingBottom = 0;
    chart.cursor.behavior = "none";
    series.columns.template.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    series.columns.template.interactionsEnabled = !suppress;
    if (!suppress) {
      series.columns.template.events.on(
        "hit",
        (ev) => {
          const item = ev.target.dataItem.component.tooltipDataItem.dataContext;
          this.props.mapClickedFilterKey(this.props.analyticsFieldKeys ?? "", item?.filterKey ?? item?.key ?? "");
        },
        this
      );
    }
  };
  render() {
    return (
      <div className="lineChart h-100 w-100">
        {!!this.props.id && this.props.id !== "" ? (
          <div className="w-100 h-100">
            <div id={this.props.id} style={{ width: "100%", height: "300px" }} />
            {this.state.chart ? <AmchartsReact chart={this.state.chart} xAxis={this.state.dateAxis} color={am4core.color("red")} /> : null}
          </div>
        ) : (
          <span className="d-none"></span>
        )}
      </div>
    );
  }
}

export default SortedBarChart;
